export default "__VITE_ASSET__7P0k3tU$__"